import React, { useState } from 'react';
import { Drawer } from 'rsuite';
import Api from 'util/Api';
import withMiniLoader from 'hoc/withMiniLoader';
import GeneralAlerts from './patial/GeneralAlerts';
import ActiveAlerts from './patial/ActiveAlerts';
import PastAlerts from './patial/PastAlerts';

const AlertsSidePanel = ({
  panelOpened,
  onCloseHandler,
  auth,
  patientId,
  startTime,
  endTime,
}) => {
  const [alerts, setAlerts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const onOpenHandler = async () => {
    let data = await Api.withAuth(auth).getAlertsSummary(
      patientId,
      startTime.format('x'),
      endTime.format('x')
    );
    await setAlerts(data);
    await setIsLoading(false);
  };

  const reloadData = async () => {
    await setIsLoading(true);
    await onOpenHandler()
  }

  const AlertPanelContent = () => {
    return (
      <>
        <Drawer.Header className={'offcanvas'}>
          <Drawer.Title><strong>Alert Log</strong></Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <GeneralAlerts alerts={alerts.active_totals} />

          <ActiveAlerts alerts={alerts.active} auth={auth} reloadData={reloadData} />

          <PastAlerts alerts={alerts.inactive} />
        </Drawer.Body>
      </>
    );
  };

  const AlertPanelContentWithLoader = withMiniLoader(
    AlertPanelContent,
    isLoading
  );

  return (
    <Drawer
      size={'xs'}
      placement={'right'}
      open={panelOpened}
      onClose={onCloseHandler}
      onOpen={onOpenHandler}
      className={'alerts-side-panel'}
    >
      <AlertPanelContentWithLoader />
    </Drawer>
  );
};

export default AlertsSidePanel;
